<template>
  <NewsletterSignupForm
    :listId="campaignMonitorListId"
    :inputPlaceholder="inputPlaceholder"
    :submitButtonText="$t('sign_up')"
    :successMessage="successMessage"
    :errorMessage="errorMessage"
    :theme="THEMES.dark"
  />
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import NewsletterSignupForm, { THEMES } from '@/components/_shared/NewsletterSignupForm.vue'

export default {
  name: 'PopupNewsletterForm',
  components: {
    NewsletterSignupForm,
  },

  data() {
    return { THEMES }
  },

  computed: {
    ...mapState('popup', ['campaignMonitorListId']),
    ...mapGetters({
      inputPlaceholder: 'popup/inputPlaceholder',
      successMessage: 'popup/success',
      errorMessage: 'popup/error',
    }),
  },
}
</script>

<i18n src="@/locales/popup_newsletter.json">
</i18n>
